///<reference path="./Store.ts"/>

/* istanbul ignore else */
if (typeof module !== "undefined") {
	module.exports = Updraft;
}
